module.exports = __webpack_public_path__ + "img/small-1.eb8732c2.jpg";